import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { FormikProps } from "formik";
import { IFollowupSchedule } from "src/interface/IFollowupSchedule";
import FollowupScheduleForm from "./followup-schedule-form";
import FollowupChilds from "./followup-childs";
import { Badge } from "@mui/material";
import { IAutoCompleteLabelValue } from "src/interface/enum/GeneralType";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
interface TabSchedulesProps {
  formik: FormikProps<any>;
  followupsSchedule: IFollowupSchedule[];
  setFollwupsSchedule: (followupsSchedule: IFollowupSchedule[]) => void;
  refetch: any;
  isEdit?: boolean;
  editors: IAutoCompleteLabelValue[];
}

export default function TabSchedules({
  formik,
  followupsSchedule,
  setFollwupsSchedule,
  refetch,
  isEdit = false,
  editors,
}: TabSchedulesProps) {
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="اطلاعات پیگیری" {...a11yProps(0)} />
          {(!isEdit || (isEdit && formik.values.parentRef === null)) && (
            <Tab
              label={
                <Badge badgeContent={followupsSchedule.length} color="primary">
                  پیگیری ها
                </Badge>
              }
              {...a11yProps(1)}
            />
          )}
        </Tabs>
      </Box>

      <CustomTabPanel value={value} index={0}>
        <FollowupScheduleForm
          editors={editors}
          formik={formik}
          isEdit={isEdit}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <FollowupChilds
          refetch={refetch}
          rows={followupsSchedule}
          setRows={setFollwupsSchedule}
        />
      </CustomTabPanel>
    </Box>
  );
}
